const SET_CART = (state, cart) => {
  state.cart = cart
}

const REMOVE_CART_ITEM = (state, cartItemId) => {
  let cartItems = state.cart.cartItems

  state.cart.cartItems = cartItems.filter(cartItem => cartItem.id != cartItemId)
}

const UPDATE_CART_ITEM = (state, updatedCartItem) => {
  let index = state.cart.cartItems.findIndex(cartItem => cartItem.id == updatedCartItem.id)

  state.cart.cartItems[index].quantity = updatedCartItem.quantity
}

const SET_LOADING = (state, value) => state.loading = value

export default {
  REMOVE_CART_ITEM,
  SET_CART,
  SET_LOADING,
  UPDATE_CART_ITEM
}
